<template>
	<div>
		<v-card class='opaqueBg' rounded>
			<v-card-text class='body-1' v-html='text' />
		</v-card>

		<v-row>
			<v-col cols='12' sm='6' v-for='contact in contacts' :key='contact.label'>
				<ContactItem :item='contact' />
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ContentService from '@/services/ContentService'
import ContactItem from '@/components/n-collections/n-items/ContactItem'

export default {
	name: 'Contact',

	components: {
		ContactItem
	},

	metaInfo: {
    title: 'Contact'
  },

	data() {
		return {
			text: '',
			contacts: []
		}
	},

	async created() {
		const { text, contacts } = await ContentService.get('contact')
		this.contacts = contacts
		this.text = text
	}
}
</script>